import React, { useEffect, useState, useMemo } from 'react';
import Select from 'react-select';
import { SEARCH_FIELD_NAMES, SELECTABLE_STEEL_TYPE_LABELS, STEEL_MAKER_NAME } from '../../../constants';
import getOptionsTypeLabel from '../../../utils/getOptionsTypeLabel';
import type { Language, SteelCategory } from '../../../types/common';
import type { OptionsType } from '../../../types/options';

interface SelectTypeEnProps {
  value: string;
  language: Language;
  selectedSteelCategory: SteelCategory;
  steelCategoryType: OptionsType[];
  selectedSteelMakerEn: string; 
  onChangeType: (fieldName: string, value: string) => void;
}

const SelectTypeEn = ({ value, language, selectedSteelCategory, steelCategoryType, selectedSteelMakerEn, onChangeType }: SelectTypeEnProps): React.ReactElement => {
  // console.log(name, value);
  const [selectedOption, setSelectedOption] = useState<OptionsType | null>(null);
  // 品種プルダウンの選択肢
  // ========================================
  // 分類プルダウンで分類が選択されていたらその配下の選択肢を表示する。
  // （選択されているかどうか、何が選択されているかはselectedSteelCategoryの値を確認すればわかる）
  // 分類が選択されていなかったら品種一覧を表示する。
  
  // JFEスチール用のフィルター条件
  const SteelTypeAichSteel: string[] = SELECTABLE_STEEL_TYPE_LABELS.AICHISTEEL.EN
  const SteelTypesJfeSteel: string[] = SELECTABLE_STEEL_TYPE_LABELS.JFESTEEL.EN
  const SteelTypesKobeSteel: string[] = SELECTABLE_STEEL_TYPE_LABELS.KOBESTEEL.EN
  
  // 品種プルダウンの選択肢をメモ化
  const options = useMemo(() => {
    const allSteelType: OptionsType[] = steelCategoryType.map((cat) => cat.children).flat();
    const selectedTypeOptions: OptionsType[] | undefined = steelCategoryType.find((category) => category.code === selectedSteelCategory)?.children;
    const baseOptions: OptionsType[] = selectedTypeOptions ?? allSteelType;
    
    // メーカー名に応じて品種をフィルタリング
    if (selectedSteelMakerEn === STEEL_MAKER_NAME.AICHISTEEL.EN) {
      return baseOptions.filter(option => 
        SteelTypeAichSteel.includes(option.nameEnglish)
      );
    }
    if (selectedSteelMakerEn === STEEL_MAKER_NAME.JFESTEEL.EN) {
      return baseOptions.filter(option => 
        SteelTypesJfeSteel.includes(option.nameEnglish)
      );
    }
    if (selectedSteelMakerEn === STEEL_MAKER_NAME.KOBESTEEL.EN) {
      return baseOptions.filter(option => 
        SteelTypesKobeSteel.includes(option.nameEnglish)
      );
    }
    
    return baseOptions;
  }, [steelCategoryType, selectedSteelCategory, selectedSteelMakerEn, SteelTypeAichSteel, SteelTypesJfeSteel, SteelTypesKobeSteel]);

  const getOptionLabel = (option: OptionsType) => getOptionsTypeLabel(option, language);
  const getOptionValue = (option: OptionsType) => getOptionsTypeLabel(option, language);

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  useEffect(() => {
    if (value !== '') {
      const newSelectedOption: OptionsType | undefined = options.find((option) => option.nameEnglish === value);
      // console.log(newSelectedOption);
      if (newSelectedOption !== undefined) {
        setSelectedOption(newSelectedOption);
      }
    } else {
      setSelectedOption(null);
    }
  }, [value]);

  // EVENT HANDLER
  // ================================================================================

  const handleOptionChange = (option: OptionsType | null): void => {
    // console.log(option);
    setSelectedOption(option);
    const newValue: string = getOptionsTypeLabel(option, language);
    onChangeType(SEARCH_FIELD_NAMES.MATERIAL_TYPE_EN, newValue);
  };

  // VIEW
  // ================================================================================

  return (
    <>
      <Select
        id={SEARCH_FIELD_NAMES.MATERIAL_TYPE_EN}
        name={SEARCH_FIELD_NAMES.MATERIAL_TYPE_EN}
        className="react-select-container"
        classNamePrefix="react-select"
        value={selectedOption}
        options={options}
        getOptionLabel={getOptionLabel}
        getOptionValue={getOptionValue}
        onChange={handleOptionChange}
        placeholder="Select..."
      />
    </>
  );
};

export default SelectTypeEn;
